<template>
<layout-customs>
    <!-- Page Content -->
    <div id="page-content-wrapper" class="community">
        <div class="container">
            <div class="line">
                <div class="col-lg-12">
                    <h1 class="line ta-center">Community</h1>
                    <div class="co-links line ta-center">
                        <a class="co-a" href="#bounty">Bounty Program</a>
                        <a class="co-a" href="#blog">Blog</a>
                        <a class="co-a" href="#podcast">Podcast</a>
                    </div>
                </div>
            </div>
            <div class="line co-line">
                <div class="col-xs-12 col-sm-5 col-md-5 col-lg-5 ta-center">
                    <img src="/static/dist/images/Community/trophy.png">
                </div>
                <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                    <h2 class="color-green" id="bounty">Bounty Program</h2>
                    <p>Do you wanna help build the future we wanna live in? Do you wanna be an active part of our community? Do you want to use your skills in helping us build our platform and get some Greens in exchange?</p>
                    <p>Check our Bounty Program! A new activity every 15 days! <a href="" class="color-green">I want some Greens!</a></p>
                </div>
            </div>
            <div class="line co-line">
                <div class="col-xs-12 col-sm-5 col-md-5 col-lg-5 f-right ta-center">
                    <img src="/static/dist/images/Community/video.png">
                </div>
                <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                    <h2 class="color-green" id="blog">Blog</h2>
                    <p>Our channel to share our ideas, our professional view and some technical information about our technology and our activities!</p><p>There’s amazing content for all levels!</p><p><a href="" class="color-green">Check it out!</a></p>
                </div>
            </div>
            <div class="line co-line">
                <div class="col-xs-12 col-sm-5 col-md-5 col-lg-5 ta-center">
                    <img src="/static/dist/images/Community/podcast-2.png">
                </div>
                <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                    <h2 class="color-green" id="podcast">Green Futurism Podcast</h2>
                    <p>Embark with us in this fun journey interviewing tech experts, designers, people in general about the world we all wanna live in. It’s our glimpse into the future with our wonder hostess Alana! It’s twice a month!</p>
                    <p><a href="" class="color-green co-ep-a">Episodes:</a> <img src="/static/dist/images/Community/spotify.png"> <img src="/static/dist/images/Community/itunes.png"></p>
                    <div class="co-player-list line">
                        <ul>
                            <li>
                                <span class="track-title color-green">03. The World without banks</span>
                                <span class="track-play-line"><span></span></span>
                                <a href="" class="download-btn"><img src="/static/dist/images/Community/download-2.png"></a>
                            </li>
                            <li>
                                <span class="track-title color-green">02. Energy in the future</span>
                                <span class="track-play-line"><span></span></span>
                                <a href="" class="download-btn"><img src="/static/dist/images/Community/download-2.png"></a>
                            </li>
                            <li>
                                <span class="track-title color-green">01. Design Fiction and Blockchain</span>
                                <span class="track-play-line"><span></span></span>
                                <a href="" class="download-btn"><img src="/static/dist/images/Community/download-2.png"></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="line co-line co-inst-box">
                <div class="line">
                    <span>Instagram Embedded content extension</span>
                </div>
            </div>
            <div class="line co-line">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <h3 class="color-green ta-center">You can also talk to us on:</h3>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class="co-soc-list ta-center">
                        <ul>
                            <li>
                                <a href=""><img src="/static/dist/images/Community/facebook-logo-in-circular-button-outlined-social-symbol.png"></a>
                            </li>
                            <li>
                                <a href=""><img src="/static/dist/images/Community/twitter-circular-button.png"></a>
                            </li>
                            <li>
                                <a href=""><img src="/static/dist/images/Community/telegram-minimal-logo-2F6E632BF2-seeklogo.com.png"></a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <button v-on:click="backToGREEN()" type="button" class="btn btn-back">Back</button>
        </div>
    </div>
    <!-- /#page-wrapper -->
</layout-customs>
</template>

<script>
import LayoutCustoms from './../../layouts/LayoutDefault.vue';

export default {
  name: 'About',
  components: {
    LayoutCustoms,
  },
  methods: {
    backToGREEN() {
      this.$router.go(-1);
    },
  },
  async created() {
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Community/index.vue